module.exports = __webpack_public_path__ + "media/common/icon_twitter_circle-f82480cb.svg";